module.exports = {"term_agreement_by_ll_owner":"Terms of Agreement by the Landlord/Property Owner"};